import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Manager } from "../models/manager.model";

export namespace ManagerActions {

  @logDispatcher
  export class GetManagersMap {
    static readonly type = '[Manager] GetManagersMap';
    constructor() {}
  }

  @logDispatcher
  export class GetManagersMapSuccess {
    static readonly type = '[Manager] GetManagersMapSuccess';
    constructor(public managers: Manager[]) {}
  }

  @logDispatcher
  export class GetManagersFail {
    static readonly type = '[Manager] GetManagersFail';
    constructor(public error: any) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Manager] Error';
    constructor(public error: any) {}
  }
}
